import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";

/**
 * Neutraliza el botón ATRÁS del navegador/móvil en toda la app: cada vez que
 * se pulsa, se vuelve a dejar la misma pantalla en el historial. Así nadie
 * se sale del examen o de un formulario a medias sin querer. La navegación
 * interna (botones de la app) sigue funcionando igual.
 */
export const BackGuard = () => {
  const location = useLocation();
  const lastWarn = useRef(0);

  useEffect(() => {
    // Entrada "señuelo": el primer ATRÁS consume ésta y no mueve la pantalla.
    window.history.pushState({ backGuard: true }, "", window.location.href);

    const onPopState = () => {
      window.history.pushState({ backGuard: true }, "", window.location.href);
      const now = Date.now();
      if (now - lastWarn.current > 2500) {
        lastWarn.current = now;
        toast.info("Usa los botones de la pantalla para moverte por la app.");
      }
    };

    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, [location.pathname]);

  return null;
};

export default BackGuard;
